import "./index.less";

const Generating = () => {
  return (
    <div className="generating">
      <div className="ball"></div>
      <div className="ball"></div>
      <div className="ball"></div>
    </div>
  );
};

export default Generating;
